import type { SurveyWaveSummary } from "./overviewTypes";
import { metricDisplay } from "./components/MetricValue";

/** Display server-owned counts/rates; never derive a missing denominator. */
export function surveyResponseText(wave: SurveyWaveSummary): string {
  if (wave.count.status === "suppressed") return wave.count.suppression === "minimum" ? "Fewer than 5 responses" : "Responses withheld to protect small groups";
  if (wave.count.status === "pending") return "Responses awaiting publication";
  const count = metricDisplay({ ...wave.count, unit: "responses" });
  if (!wave.rateAvailable) return `${count} · ${wave.rateMessage || "rate not available by role"}`;
  const rate = wave.rate;
  if (rate?.value !== null && rate?.value !== undefined && rate.numerator !== undefined && rate.denominator !== undefined) return `${rate.numerator} of ${rate.denominator} (${metricDisplay(rate)})`;
  return `${count} · rate ${rate?.status === "suppressed" ? "withheld to protect small groups" : "not available"}`;
}
